import { render } from "./ResultsBanner.vue?vue&type=template&id=83e80a28&scoped=true"
import script from "./ResultsBanner.vue?vue&type=script&lang=js"
export * from "./ResultsBanner.vue?vue&type=script&lang=js"

import "./ResultsBanner.vue?vue&type=style&index=0&id=83e80a28&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4098699732/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e80a28"]])

export default __exports__